import apisauce from 'apisauce'
import { API } from 'utils/constants'
import { isNil } from 'lodash'

export const getParams = (params = {}) => {
  let temp = new URLSearchParams()
  Object.entries(params).forEach(([key, value]) => {
    if (!isNil(value)) temp.set(key, value.join?.(',') || value)
  })
  return Array.from(temp.values()).length ? `?${temp.toString()}` : ''
}

const dondeAPI = apisauce.create({
  baseURL: API.BASE_URL,
  headers: {},
  timeout: 1000 * 60 * 3,
})

export default dondeAPI
